import React, { useCallback } from 'react'
import { Trans } from 'react-i18next'

import { ApiError, submitForm as apiSubmitForm } from '@fullfabric/public-api'

import { useQueryOpts } from '../../utils/queryOpts'
import { getUtmParams } from '../../utils/utm'

export default function useHandleSubmit({
  redirectTo,
  formId,
  externalDomainToken,
  onStartSubmit,
  onSubmitted,
  onNotSubmitted,
  altchaPayload,
  utmTracking
}) {
  onSubmitted ||= () => {}

  const queryOpts = useQueryOpts()

  return useCallback(
    async (submissionData) => {
      try {
        onStartSubmit && onStartSubmit()

        // altcha payload is not included in the submission data by default
        // so we need to append it manually
        submissionData.append('altcha_payload', altchaPayload)

        const utmParams = utmTracking === false ? null : getUtmParams()

        await apiSubmitForm(formId, submissionData, {
          ...queryOpts,
          externalDomainToken,
          query: utmParams || undefined
        })

        if (redirectTo) window.open(redirectTo, 'form-success-redirect-tab')

        onSubmitted()
      } catch (err) {
        onNotSubmitted && onNotSubmitted(parseError(err))
      }
    },
    [
      externalDomainToken,
      formId,
      redirectTo,
      queryOpts,
      onSubmitted,
      onStartSubmit,
      onNotSubmitted,
      altchaPayload,
      utmTracking
    ]
  )
}

function parseError(err) {
  if (err instanceof ApiError && err.status >= 400 && err.status < 500)
    return err.data

  return {
    message: (
      <Trans>
        There was an error in your submission, please try again in a few
        seconds. If the issue persists, please contact us.
      </Trans>
    )
  }
}
